const theme = {
  successColor: '#56efc4',
  dangerColor: '#fab1a0',
  dangerColorText: '#d63031',
  largeBgColor: 'white',
};

export default theme;
